import {Injectable} from '@angular/core';
import {Observable, of} from 'rxjs';
import {BaseItemRequestPayload,} from '../models/item.model';
import {CreateVariation} from '@emm/common-items/models/variation.model';

@Injectable()
export class MockDataService {

    constructor(
    ) {}

    createItem(item: BaseItemRequestPayload): Observable<BaseItemRequestPayload> {
        return of(item);
    }

    createVariation(variation: CreateVariation): Observable<any> {
        return of(variation);
    }
}
